import { Button, Collapse } from 'antd';
import { FC } from 'react';
import { CollapseHeader } from './CollapseHeader';
import styles from './SortByTogglers.module.scss';

export interface ItemSortByOption {
  key: string;
  title: string;
  isSelected: boolean;
}

interface Props {
  title: string;
  className?: string;
  options: ItemSortByOption[];
  selectedOptionKey?: string;
  onItemSelect: (selectedItem: ItemSortByOption) => void;
}
const SortByTogglers: FC<Props> = ({ title, options, className, selectedOptionKey, onItemSelect }) => {
  const { Panel } = Collapse;

  enum SortByTitle {
    A_TO_Z = 'A to Z',
    MOST_VIEWED = 'Most viewed',
    RECENTLY_ADDED = 'Recently Added',
  }

  return (
    <Collapse
      defaultActiveKey={['1']}
      // collapsible="header"
      // onChange={onChange}
      ghost
      className={`${styles.container} ${className || ''}`}
    >
      <Panel
        showArrow={false}
        header={<CollapseHeader title={title} badge={SortByTitle[selectedOptionKey]} />}
        key="1"
        className={styles.containerContent}
      >
        <div className={styles.contentOptions}>
          {options.map((option) => (
            <Button
              key={option.key}
              className={`${styles.contentOption} ${selectedOptionKey === option.key ? styles.selectedOption : ''}`}
              onClick={() => onItemSelect(option)}
            >
              {option.title}
            </Button>
          ))}
        </div>
      </Panel>
    </Collapse>
  );
};

export { SortByTogglers };
